import { m8API } from 'services/production/m8';
import { PartnerRewardCreationService } from 'types/services';

export const createPartnerReward: PartnerRewardCreationService = async (
  values
) => {
  if (values.rewardId) {
    return m8API.admin.updatePartnerPayment({
      idPayment: values.rewardId,
      amount: values.amount,
      comment: values.comment,
    });
  }

  return m8API.admin.addPartnerPayment({
    idPartner: values.partnerId,
    amount: values.amount,
    comment: values.comment,
  });
};
